import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  search,
  searchContactNo,
) => {
  try {
    return await GET(
      `/admin/management/master?page=${currentPage || 1}&per_page=${
        perPage || 10
      }&name=${search || ""}&contact=${searchContactNo || ""}`,
    );
  } catch (error) {
    console.error("Error fetching Master list:", error);
    throw error;
  }
};

export const findOne = async (id) => {
  try {
    return await GET(`/admin/management/master/${id}`);
  } catch (error) {
    console.error(`Error fetching Master with id ${id}:`, error);
    throw error;
  }
};

export const Create = async (data) => {
  try {
    return await POST(`/admin/management/master`, data);
  } catch (error) {
    console.error("Error creating Master:", error);
    throw error;
  }
};

export const Update = async (id, data) => {
  try {
    return await PUT(`/admin/management/master/${id}`, data);
  } catch (error) {
    console.error(`Error updating Master ${id}:`, error);
    throw error;
  }
};

export const Status = async (id) => {
  try {
    return await POST(`/admin/management/master/${id}`);
  } catch (error) {
    console.error(`Error updating status for Master ${id}:`, error);
    throw error;
  }
};

export const Delete = async (id) => {
  try {
    return await DELETE(`/admin/management/master/${id}`);
  } catch (error) {
    console.error(`Error deleting Master ${id}:`, error);
    throw error;
  }
};

// Deposit & Withdrawal with better error handling
export const Deposit = async (data) => {
  try {
    const response = await POST(`/admin/management/statement/deposit`, data);
    return response;
  } catch (error) {
    console.error("Deposit failed:", error?.response?.data || error);
    throw error; // Let the component handle the UI error
  }
};

export const Withdrawal = async (data) => {
  try {
    const response = await POST(`/admin/management/statement/withdrawal`, data);
    return response;
  } catch (error) {
    console.error("Withdrawal failed:", error?.response?.data || error);
    throw error;
  }
};
